import verifiedBadge from '../images/verified_artist_page.png'
import defaultAlbumArt from '../images/sm_album_art_placeholder.png'
import NftBadge from '../images/nft_badge.png'
import SonarNavInvert from '../images/sonar_muse_logo_nav_invert.png'
import { DEFAULT_IMAGE } from '../components/GravatarAPI'
import logo from "../images/sonar_muse_logo_nav1.png";
import invertedLogo from "../images/sonar_muse_logo_nav_invert1.png";
import logo2 from "../images/sonar_muse_logo_nav2.png";
import invertedLogo2 from "../images/sonar_muse_logo_nav_invert2.png";
import wakeAndBakeVibez from "../images/wake_and_bake_vibez.png"
import artistBadge from "../images/artist_page_owner.png"
import labelRegistration from "../images/label_registration_create_new.png"
import podcastersRegistration from "../images/podcaster_registration.png"
import artistRegistration from "../images/artist_registration.png"
import artistRegistrationClaim from "../images/artist_registration_claim.png"
import artistRegistrationCreate from "../images/artist_registration_create_new.png"
import swerlLogo from  "../images/swerl_logo.png"
import swerlLogoInvert from  "../images/swerl_logo_invert.png"

export default function ImageUtils(){

    return {
        verifiedBadge,
        defaultAlbumArt,
        NftBadge,
        artistBadge,
        SonarNavInvert,
        DEFAULT_IMAGE,
        swerlLogo,
        swerlLogoInvert,
        logo,
        logo2,
        invertedLogo,
        invertedLogo2,
        wakeAndBakeVibez,
        artistRegistrationClaim,
        artistRegistrationCreate,
        labelRegistration,
        artistRegistration,
        podcastersRegistration

    }



}




